export default function ContractCIA({
  isChecked,
  handleCheckboxChange,
  handleNextButtonClick,
}) {
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">Becker CIA方案</div>

      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          Becker CIA 方案購買須知與同意事項（請務必詳閱）
        </h5>
        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            
<ol class="main-list">
  <li>
    <strong>訂購程序、審閱期與契約成立</strong>
    <ol>
      <li>
        <strong>訂購程序</strong>
        <ol>
          <li>購買方案者，須填妥本訂購單資料表，完整審閱本購買須知與相關規定後，完成付費，方符合訂購程序。</li>
          <li>繳費前，請先確認購買產品內容、方案項目、費用及相關使用限制。</li>
        </ol>
      </li>
      <li>
        <strong>審閱期與購買者資格</strong>
        <ol>
          <li>購買前請確認已完整審閱本購買須知與相關規定，審閱期已達五日。</li>
          <li>購買方案者保證為完全行為能力人，或為已得法定代理人同意之限制行為能力人。</li>
        </ol>
      </li>
      <li>
        <strong>契約成立與電子簽名</strong>
        <ol>
          <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容。</li>
          <li>購買者同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。</li>
          <li>購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
    <strong>退費、七日猶豫期與數位內容提供</strong>
    <ol>
      <li>
        <strong>數位內容與七日解除權排除</strong>
        <ol>
          <li>本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第 2 條可排除消費者保護法第 19 條七日解除權之合理例外情事者。</li>
          <li>本人知悉並同意，本商品屬非以有形媒介提供之數位內容及／或一經提供即為完成之線上服務；一經帳號開通、登入、教材領取或課程內容提供，即排除消保法第 19 條七日解除權之適用。</li>
        </ol>
      </li>
      <li>
        <strong>七日猶豫期內退費</strong>
        <ol>
          <li>若商品未經領取、未開始參加課程、且未登入任何產品內含學習帳號時，購買後七日猶豫期內得要求退費。</li>
        </ol>
      </li>
      <li>
        <strong>帳號開通、教材領取或登入後之限制</strong>
        <ol>
          <li>除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通或登入使用後，學員不得任意要求退費或暫停效期。</li>
          <li>學員之個人教材軟體帳號經首次登入後，教材恕不退費，亦不得要求暫停效期。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
    <strong>CIA 方案內容、授權與使用效期</strong>
    <ol>
      <li>
        <strong>個人授權與使用限制</strong>
        <ol>
          <li>Becker CIA Exam Review 系列為美國進口原版教材與軟體，方案內容之教材、課程、諮詢服務皆限購買者本人使用。</li>
          <li>學員應遵循 Becker 服務政策，且嚴禁任何形式之轉售、轉贈、轉讓及分享。</li>
          <li>若經發現有轉售、轉贈、轉讓、分享或其他非本人使用情形，學員應賠償購買總價十倍之懲罰性違約金及損害賠償。</li>
        </ol>
      </li>
      <li>
        <strong>方案使用效期</strong>
        <ol>
          <li>國際內部稽核師 Becker CIA Exam Review 自修全科、單科系列方案之使用權限效期，於軟體購買當日起算後之二十四個月後終止。（Your Becker CIA Exam Review license will expire 24 months from the date of purchase.）</li>
          <li>國際內部稽核師 Becker CIA Exam Review 自修挑戰考試（Challenge Exam）方案之使用權限效期，於軟體購買當日起算後之十八個月後終止。（Your Becker CIA Challenge Exam Review license will expire 18 months from the date of purchase.）</li>
          <li>所有方案內含之服務、課程、課本，均須於效期內領取與使用。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
    <strong>教材供應與版本管理</strong>
    <ol>
      <li>
        <strong>教材提供與紙本教科書</strong>
        <ol>
          <li>Becker CIA 方案提供電子教科書；是否包含紙本教科書，依各方案實際公告為準。</li>
          <li>因個人筆記習慣須加購紙本教科書者，每本需酌收加購費用，加購價格依美國 Becker 規定之定價加上國際運費計算。</li>
        </ol>
      </li>
      <li>
        <strong>教材版本更新與新版書本加購</strong>
        <ol>
          <li>遇 Becker 系列教科書版本更新而須加購新版書本者，需於使用效期內，檢附「過去三個月內應考而成績未及格證明」或「即將赴考之考場預約（exam appointment confirmation）證明」作為購買憑證。</li>
          <li>前項新版書本每本需酌收加購費用，加購價格依美國 Becker 規定之定價加上國際運費計算。</li>
          <li>若遇書籍取用完畢，需等待國際郵務寄達台灣，無法指定取書時間。</li>
        </ol>
      </li>
      <li>
        <strong>教材供應與變更聲明</strong>
        <ol>
          <li>原廠 Becker Professional Education 若有停產或規格調整，Becker Taiwan 保有調整或停止供貨之權利，恕不另行賠償。</li>
          <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利，亦保留任何因賣方代理原廠更改貨品規格而更改之權利，並對此不負擔責任。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
    <strong>帳號與通訊管理</strong>
    <ol>
      <li>
        <strong>帳號與登入管理</strong>
        <ol>
          <li>學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知。</li>
          <li>利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。</li>
          <li>因非可歸責於 Becker Taiwan（捷進）之事由導致登入密碼外洩時，學員應儘速通知；Becker Taiwan（捷進）除提供必要協助外，不負任何法律上責任。</li>
          <li>為提升服務品質及確保學員正確使用本教材，Becker Professional Education 與 Becker Taiwan（捷進）將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址（IP address）等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況，Becker Taiwan（捷進）有權中止該帳號之軟體權限。</li>
        </ol>
      </li>
      <li>
        <strong>E-mail 通訊義務</strong>
        <ol>
          <li>學員所提供之 E-mail 必須有效期達二十四個月以上。</li>
          <li>所有帳號通知、課程資訊、系統更新皆以該信箱為唯一正式聯絡方式。</li>
          <li>購買後請自行定期收信。若因未定期查收郵件而錯過通知，或導致相關權益受影響，學員應自負相關責任。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
    <strong>使用設備與連線需求</strong>
    <ol>
      <li>
        <strong>基本設備與系統需求</strong>
        <ol>
          <li>使用本服務應具備下列軟硬體設備基本規格及要求：
            <ul>
              <li>Windows PC/NB：Windows 7 以上</li>
              <li>Apple PC/NB：macOS 10 以上</li>
              <li>Apple 行動裝置：iOS 13.0 以上</li>
              <li>Android 行動裝置：Android 8.0 以上</li>
              <li>行動裝置限定使用 APP 版觀看課程</li>
              <li>連線需求：寬頻網路下載速度 20Mbps 以上</li>
            </ul>
          </li>
        </ol>
      </li>
      <li>
        <strong>網路使用建議</strong>
        <ol>
          <li>不建議使用無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。</li>
          <li>其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
    <strong>個人資料保護與隱私權聲明</strong>
    <ol>
      <li>
        <strong>蒐集、處理及利用目的</strong>
        <ol>
          <li>Becker Taiwan（捷進）基於本訂購單履約之目的，蒐集、處理並利用您的個人資料。本公司將依個人資料保護法第 8 條第 1 項之要求，向您告知以下事項。</li>
          <li>蒐集目的：依照 101 年 10 月 1 日修正之個人資料保護法之特定目的及個人資料之類別，040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務。</li>
        </ol>
      </li>
      <li>
        <strong>個人資料類別</strong>
        <ol>
          <li>C001 電子郵件、中文姓名、英文拼音全名、電話號碼。</li>
          <li>C002 金融機構帳戶號碼與姓名。</li>
          <li>C003 身分證字號。</li>
          <li>C036 是否曾訂購本公司產品、得知本公司之管道。</li>
          <li>C038 在職身分。</li>
          <li>C051 所屬或畢業學校與科系。</li>
        </ol>
      </li>
      <li>
        <strong>個人資料利用期間、地區、對象及方法</strong>
        <ol>
          <li>本公司會於契約履行、學員服務、帳務處理、法令保存期間及爭議處理所必要期間內利用您的個人資料。</li>
          <li>利用地區包含中華民國境內及 Becker 原廠帳號開通、服務提供所必要之境外地區。</li>
          <li>本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。</li>
          <li>本公司並將分析您提供之類別 C036、C038、C051 等資訊，以增進本公司之服務。</li>
          <li>除為履行本契約、開通 Becker 原廠帳號、寄送商品、金流／物流／系統服務所必要，或依法令要求外，在未經您的同意下，我們不會任意將您的個人資料提供給第三人或作不當利用。</li>
        </ol>
      </li>
      <li>
        <strong>個資不完整之影響與權利行使</strong>
        <ol>
          <li>如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。</li>
          <li>您得行使個資法第 3 條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。</li>
        </ol>
      </li>
    </ol>
  </li>
  <li>
                <div className="font-weight-bold">付費購買、匯款資訊</div>

                <ol>
                  <li>
                    <strong>在台購買</strong>

                    <table className="table table-bordered mt-2 mb-3">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>收款人戶名</th>
                          <td>捷進顧問有限公司</td>
                        </tr>
                        <tr>
                          <th>受款銀行</th>
                          <td>華南商業銀行信維分行（代碼：008）</td>
                        </tr>
                        <tr>
                          <th>收款人帳號</th>
                          <td>149-10-010062-0</td>
                        </tr>
                        <tr>
                          <th>匯款金額</th>
                          <td>
                            以新台幣付費，依各方案價格（若需快遞書籍，請加上運費）。
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>

                  <li>
                    <strong>海外購買</strong>

                    <table className="table table-bordered mt-2 mb-3">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Recipient Name</th>
                          <td>Direct Line Consulting Co.</td>
                        </tr>
                        <tr>
                          <th>Account Number</th>
                          <td>149-10-010062-0</td>
                        </tr>
                        <tr>
                          <th>Bank</th>
                          <td>Hua Nan Commercial Bank Ltd.</td>
                        </tr>
                        <tr>
                          <th>Branch</th>
                          <td>Hsin-Wei Branch</td>
                        </tr>
                        <tr>
                          <th>SWIFT Code（Bank ID）</th>
                          <td>HNBKTWTP149</td>
                        </tr>
                        <tr>
                          <th>Bank Address</th>
                          <td>
                            2F, No.6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City,
                            Taiwan
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ol>
              </li>
  <li>
    <strong>契約終止</strong>
    <ol>
      <li>學員如有違反強制禁止規定或公序良俗之行為，或違反本契約經限期改正仍未改正者，Becker Taiwan（捷進）得終止本契約，學員不得異議。</li>
      <li>如學員自行或因可歸責於己之事由終止契約者，除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通或登入使用後，學員不得任意要求退費或暫停效期。</li>
    </ol>
  </li>
</ol>

          </div>

          <div className="text-center">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>
            <div
              className="btn btn-primary m-3"
              onClick={handleNextButtonClick}
            >
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
